import React, { useEffect, useState } from "react";
import { Button, FormLabel, FormInput, CircleCheckbox } from "./StyledElements";
import { useCourseContext } from "../contexts/CoursesContext";
import { addContentStatusResponse } from "../services/courses";
import swal from "sweetalert2";

export const RejectionBlock = ({ contentPublicId, style = {} }) => {
  const { contentStatuses, updateContentStatus } = useCourseContext();
  const [rejectionStatuses, setRejectionStatuses] = useState([]);
  const [rejectionResponseComment, setRejectionResponseComment] = useState("");
  const [savingContentStatus, setSavingContentStatus] = useState(false);

  useEffect(() => {

    setRejectionResponseComment("");

    const currentRejections = contentStatuses.filter((status) => status.content_public_id === contentPublicId);
    setRejectionStatuses(currentRejections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentPublicId]);




  return (
    rejectionStatuses?.map((rejectionStatus, index) => (
      <div key={`reject-${index}`} style={{ display: "flex", flexDirection: "column", marginBottom: "14px", lineHeight: "20px", width: "100%", borderRadius: "10px", padding: "10px 20px", backgroundColor: "rgba(255, 0, 0, 0.2)" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
          <CircleCheckbox checked={rejectionStatus.resolved} style={{ marginRight: "20px" }} onChange={(checked) => {
            const newRejectionStatuses = [...rejectionStatuses];
            newRejectionStatuses[index].resolved = checked;
            setRejectionStatuses(newRejectionStatuses);
          }} />
          <FormLabel label={`${rejectionStatus.comments} - ${rejectionStatus.user_firstname} ${rejectionStatus.user_lastname} (${new Date(rejectionStatus.created_at).toLocaleString()})`} style={{ marginBottom: "0px", color: "var(--main-font-color)", fontStyle: "italic" }} />
        </div>
        {
          rejectionStatus?.responses ? (
            <>
              {
                rejectionStatus?.responses.map((response, responseIndex) => (
                  <div key={`response-${responseIndex}`} style={{ marginLeft: "40px", marginTop: "10px", color: "var(--main-font-color)", fontStyle: "italic" }}>
                    {response.comment} - {response.user_firstname} {response.user_lastname} ({new Date(response.created_at).toLocaleString()})
                  </div>
                ))
              }
            </>
          ) : null
        }
        <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end", gap: "10px" }}>
          <FormInput as="textarea" value={rejectionResponseComment} placeholder="Add response..." onChange={(e) => {
            setRejectionResponseComment(e.target.value);
          }} />
          <Button onClick={async () => {

            setSavingContentStatus(true);
            const results = await addContentStatusResponse(rejectionStatus.public_id, rejectionStatus.resolved, rejectionResponseComment);
            console.log("!! RESULTS FROM ADD RESPONSE: ", results);
            if (results.success) {
              if (results.status_comment) {
                const newRejectionStatuses = [...rejectionStatuses];
                newRejectionStatuses[index].responses.push(results.status_comment);
                setRejectionStatuses(newRejectionStatuses);
                setRejectionResponseComment("");
              }
              if (results.content_status) {
                updateContentStatus(results.content_status);
              }
            } else {
              swal.fire({
                title: "Error",
                text: results.error || "An error occurred while adding the response.",
                icon: "error",
              });
            }

            setSavingContentStatus(false);

          }}>{savingContentStatus ? "Saving..." : "Save"}</Button>

        </div>
      </div>
    ))

  )
};

export default RejectionBlock;
